/**
 * Defensive `localStorage` access.
 *
 * Safari in private mode and hardened browser profiles throw on both read and
 * write. Persisting a preference must never break the tuner, so every access
 * degrades to "no stored value".
 */

/** Read a string, or null when unavailable, empty or inaccessible. */
export function readSetting(key: string): string | null {
  try {
    const value = globalThis.localStorage.getItem(key)
    return value === null || value === '' ? null : value
  } catch {
    return null
  }
}

/** Persist a string. Returns false when storage refused the write. */
export function writeSetting(key: string, value: string): boolean {
  try {
    globalThis.localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

/** Remove a stored value, ignoring storage failures. */
export function clearSetting(key: string): void {
  try {
    globalThis.localStorage.removeItem(key)
  } catch {
    // Nothing to do: the value is unreachable either way.
  }
}
